export const matchUrlPath = (pathname, matches) => {
    for (const match of matches) {
        if (match.test(pathname))
            return true;
    }
    return false;
};
